export enum Cursor {
  POINTER = "pointer",
  MOVE = "move",
  GRAB = "grab",
  GRABBING = "grabbing",
  NS_RESIZE = "ns-resize",
  EW_RESIZE = "ew-resize"
}
